import {
  EventDispatcher,
  Color,
  HemisphereLight,
  CameraHelper,
  AmbientLight,
  RectAreaLight,
  DirectionalLight,
  SpotLight,
  PointLight,
  // HemisphereLightHelper,
  PointLightHelper,
  DirectionalLightHelper,
  SpotLightHelper,
} from "three";
// import { EVENT_LIGHT_REFRESH } from '../core/events';
export class Lights3D extends EventDispatcher {
  constructor(scene) {
    super();
    this.scene = scene;
    this.tol = 1;
    this.dirLight = null;
    this.height = 500;
    this.helpersize = 60;
    this.helperColor = 0x000000;
  }

  __addSpotlight(position, intensity, color) {
    const col = 0xffffff;
    const inten = 1;
    const distance = 0;
    const angle = Math.PI * 0.1;
    const penumbra = 0;

    let d = this.height + this.tol;
    let spotLight = new SpotLight(col, inten, distance, angle, penumbra);
    position
      ? spotLight.position.set(position.x, position.y, position.z)
      : spotLight.position.set(0, this.height, 0);
    intensity ? (spotLight.intensity = intensity) : (spotLight.intensity = 1);
    color
      ? (spotLight.color = new Color(color))
      : (spotLight.color = new Color(col));

    spotLight.name = spotLight.type;
    spotLight.castShadow = true;
    spotLight.shadow.mapSize.width = 500;
    spotLight.shadow.mapSize.height = 500;
    // spotLight.shadow.camera.fov = 45;
    // spotLight.shadow.camera.near = 10;
    // spotLight.shadow.camera.far = 200;
    spotLight.shadow.camera.near = 0.1; // default
    spotLight.shadow.camera.far = this.height * 2; // default
    spotLight.shadow.camera.left = -d;
    spotLight.shadow.camera.right = d;
    spotLight.shadow.camera.top = d;
    spotLight.shadow.camera.bottom = 0;
    spotLight.shadow.bias = -0.0005;
    // spotLight.shadow.focus = 1;
    this.scene.add(spotLight);
    this.scene.__light3d.push(spotLight);

    const spotLightHelper = new SpotLightHelper(spotLight);
    spotLightHelper.name = spotLightHelper.type;
    spotLightHelper.visible = false;

    this.scene.add(spotLightHelper);
    this.scene.__lightHelper[spotLight.id] = spotLightHelper;
  }
  __addPointLight(position, intensity, color) {
    let pointLight = new PointLight(0xffffff, 1, 60);
    // pointLight.position.set(0, 10, 4);
    position
      ? pointLight.position.set(position.x, position.y, position.z)
      : pointLight.position.set(0, 0, 0);
    intensity ? (pointLight.intensity = intensity) : (pointLight.intensity = 1);
    color
      ? (pointLight.color = new Color(color))
      : (pointLight.color = new Color(0xffffff));

    pointLight.name = pointLight.type;
    this.scene.add(pointLight);
    this.scene.__light3d.push(pointLight);

    const pointLightHelper = new PointLightHelper(pointLight, this.helpersize);
    this.scene.add(pointLightHelper);
    this.scene.__lightHelper[pointLight.id] = pointLightHelper;
  }
  __addRectAreaLight(position, intensity, color) {
    const width = 100;
    const height = 100;
    const inten = 1;
    let rectAreaLight = new RectAreaLight(0xffffff, inten, width, height);
    rectAreaLight.name = rectAreaLight.type;
    // rectAreaLight.position.set(5, 5, 0);
    position
      ? rectAreaLight.position.set(position.x, position.y, position.z)
      : rectAreaLight.position.set(5, 5, 0);
    intensity
      ? (rectAreaLight.intensity = intensity)
      : (rectAreaLight.intensity = inten);
    color
      ? (rectAreaLight.color = new Color(color))
      : (rectAreaLight.color = new Color(0xffffff));

    rectAreaLight.lookAt(0, 0, 0);

    this.scene.add(rectAreaLight);
  }

  __addDirectionalLight(position, intensity, color) {
    let d = 2000;

    let directionalLight = new DirectionalLight(0xffffff, 1);
    position
      ? directionalLight.position.set(position.x, position.y, position.z)
      : directionalLight.position.set(0, this.height, 0);
    intensity
      ? (directionalLight.intensity = intensity)
      : (directionalLight.intensity = 1);
    color
      ? (directionalLight.color = new Color(color))
      : (directionalLight.color = new Color(0xffffff));

    directionalLight.name = directionalLight.type;
    directionalLight.castShadow = true;
    directionalLight.shadow.mapSize.width = 2048; // default
    directionalLight.shadow.mapSize.height = 2048; // default
    directionalLight.shadow.camera.near = -this.height * 4; // default
    directionalLight.shadow.camera.far = this.height * 4; // default
    directionalLight.shadow.camera.left = -d;
    directionalLight.shadow.camera.right = d;
    directionalLight.shadow.camera.top = d;
    directionalLight.shadow.camera.bottom = -d;
    directionalLight.shadow.bias = -0.0005;
    // directionalLight.shadow.bias = -0.0001;
    this.scene.add(directionalLight);

    const sunhelper = new CameraHelper(directionalLight.shadow.camera);
    sunhelper.visible = true;
    this.scene.add(sunhelper);

    const helper = new DirectionalLightHelper(
      directionalLight,
      this.helpersize,
      this.helperColor
    );
    helper.visible = true;
    this.scene.add(helper);
  }

  __addSunlLight(position, intensity, color, sunTime) {
    // this.initGeolocation();
    // let d = this.height + this.tol;
    // let d = 2;
    let b = new Date();
    b.setHours(10);

    let sunLight = new DirectionalLight(0xffffff, 1);
    position
      ? sunLight.position.set(position.x, position.y, position.z)
      : sunLight.position.set(0, 100, 30);
    intensity ? (sunLight.intensity = intensity) : (sunLight.intensity = 2);
    color
      ? (sunLight.color = new Color(color))
      : (sunLight.color = new Color(0xffffff));
    sunLight.castShadow = true; // default false
    this.scene.add(sunLight);

    sunLight.name = "SunLight";
    // sunLight.shadow.mapSize.width = 512 * 1; // default
    // sunLight.shadow.mapSize.height = 512 * 1; // default
    // sunLight.shadow.camera.near = -this.height * 1; // default
    // sunLight.shadow.camera.far = this.height * 1; // default
    // sunLight.shadow.camera.left = -d * 4;
    // sunLight.shadow.camera.right = d * 4;
    // sunLight.shadow.camera.top = d * 4;
    // sunLight.shadow.camera.bottom = -d * 4;
    // sunLight.shadow.bias = -0.0002;
    // sunLight.target.updateMatrixWorld();
    // const helper = new DirectionalLightHelper(sunLight, this.helpersize, this.helperColor);
    // helper.visible = false;
    // this.scene.add(helper);

    // const sunhelper = new CameraHelper(sunLight.shadow.camera);
    // this.scene.add(sunhelper);

    // const cahelper = new DirectionalLightHelper(sunLight, this.helpersize, this.helperColor);
    // helper.visible = true;
    // this.scene.add(cahelper);
  }

  __addAmbientlight(position, intensity, color) {
    let ambientLight = new AmbientLight(0xffffff); // soft #FFFFFF light
    // ambientLight.intensity = 1;
    position
      ? ambientLight.position.set(position.x, position.y, position.z)
      : ambientLight.position.set(0, 0, 0);
    intensity
      ? (ambientLight.intensity = intensity)
      : (ambientLight.intensity = 1);
    color
      ? (ambientLight.color = new Color(color))
      : (ambientLight.color = new Color(0xffffff));

    ambientLight.name = ambientLight.type;
    this.scene.add(ambientLight);
  }

  __addHemisphereLight(position, intensity) {
    const skyColor = 0xffd6d6; // blue color #00aaff 0xcde9f7 red color 0xffd6d6
    const groundColor = 0xffffff;
    const inten = 4;

    let hemisphereLight = new HemisphereLight(skyColor, groundColor, inten);
    position
      ? hemisphereLight.position.set(position.x, position.y, position.z)
      : hemisphereLight.position.set(0, 0, 0);
    intensity
      ? (hemisphereLight.intensity = intensity)
      : (hemisphereLight.intensity = inten);
    // light.position.set(0, this.height, 100);
    hemisphereLight.name = hemisphereLight.type;

    this.scene.add(hemisphereLight);

    // const HemisphereLighthelper = new HemisphereLightHelper(
    //   hemisphereLight,
    //   this.helpersize,
    //   this.helperColor
    // );
    // HemisphereLighthelper.visible = false;
    // this.scene.add(HemisphereLighthelper);
  }
}
